import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumIroType, useGetIroQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'severityFullAssessment',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetIroQuery = useGetIroQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetIroQuery.result,
      onResult = _useGetIroQuery.onResult;
    onResult(function (_ref) {
      var data = _ref.data;
      if (data !== null && data !== void 0 && data.getIro) {
        if (disabled.value === false && !data.getIro.finalSeverity) {
          editing.value = true;
        }
      }
    });
    var disabled = computed(function () {
      if ([EnumIroType.PositiveImpact, EnumIroType.NegativeImpact].includes(item.value.type)) {
        if (!item.value.levelOfImpact) {
          return true;
        }
      }
      return false;
    });
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getIro) || {};
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      updateIRO = _useUpdateIroMutation.mutate,
      onDone = _useUpdateIroMutation.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var editing = ref(false);
    return {
      __sfc: true,
      route: route,
      result: result,
      onResult: onResult,
      disabled: disabled,
      item: item,
      updateIRO: updateIRO,
      onDone: onDone,
      editing: editing,
      EnumIroType: EnumIroType
    };
  }
});